import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ServicesService } from '../../../services/services.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

export interface PoData {
    ContractNumber: string;
    EndDate: string;
    PoNumber: string;
    StartDate: string;
    Status: string;
    Balance: string;
    Consumed: string;
    Purchased: string
}


@Component({
  selector: 'app-services-po',
  templateUrl: './services-po.component.html',
  styleUrls: ['./services-po.component.scss']
})
export class ServicesPoComponent implements AfterViewInit {

    pagecode: string = "serv-po";
    module: string = "services";

    accessdenied: boolean = false;

    displayedColumns: string[] = ['po', 'startDate', 'endDate', 'purchased', 'consumed', 'balance', 'status'];
    dataSource: MatTableDataSource<PoData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    loadingMessage: string = "Loading...";

    constructor(private route: ActivatedRoute, private _router: Router, private servicesService: ServicesService, private authentication: AuthenticationService, private common: CommonService) {

        this.dataSource = new MatTableDataSource(this.AccountPO);

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);
                        // load page data
                        this.getAccountPO();
                        //
                        window.scroll(0, 0);
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }


    }
    AccountPO: Array<PoData> = [];
    getAccountPO() {
        this.servicesService.getAccountPOs(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        for (var i = 0; i < res.data.length; i++) {
                            this.AccountPO.push({
                                Balance: res.data[i].Total_PS_Days_Balance__c,
                                Consumed: res.data[i].Total_PS_Days_Consumed__c,
                                ContractNumber: res.data[i].ContractNumber,
                                EndDate: res.data[i].EndDate,
                                PoNumber: res.data[i].PO_Number__c,
                                Purchased: res.data[i].Total_PS_Days_Purchased__c,
                                StartDate: res.data[i].StartDate,
                                Status: res.data[i].Status
                            });
                        }
                        this.dataSource = new MatTableDataSource(this.AccountPO);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                        this.loadingMessage = "No data found";
                    }

                }
                else {
                    console.error("getAccountPO()", res.error_message);
                }
                //console.log("this.AccountPO", this.AccountPO);
            },
            (err: any) => {
                console.error("getAccountPO err", err);
            }
        );
    }




}